import { render, staticRenderFns } from "./RelatorioPedidoGeral.vue?vue&type=template&id=261d6a76"
import script from "./RelatorioPedidoGeral.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidoGeral.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPedidoGeral.vue?vue&type=style&index=0&id=261d6a76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports